import { IFile } from '../NativeDevice/fileSystem';
import OfflineCache from '../OfflineCache/OfflineCache';

export class PluginDownloader {
	constructor(
		private offlineCache: OfflineCache,
		private getStaticBaseUrl: () => string,
	) {}

	public async getOrDownloadPlugin(archiveUri: string, mainFileName: string, md5Checksum: string): Promise<IFile | null> {
		const pluginLocalFolder = this.getPluginDirectory(archiveUri, md5Checksum);
		const existsPluginFile = await this.offlineCache.fileExists(pluginLocalFolder);
		if (!existsPluginFile) {
			await this.downloadPluginToLocalStorage(archiveUri, pluginLocalFolder, mainFileName);
		}

		return await this.offlineCache.getFile(pluginLocalFolder + '/' + mainFileName);
	}

	private async downloadPluginToLocalStorage(pluginFilePath: string, localDirPath: string, mainFileName: string) {
		const relativePath = this.removeStaticUrl(pluginFilePath);
		await this.ensurePluginIsDownloaded(relativePath);
		await this.ensurePluginIsExtracted(relativePath, localDirPath);

		const mainFilePath = localDirPath + '/' + mainFileName;
		return await this.offlineCache.getFile(mainFilePath);
	}

	private async ensurePluginIsDownloaded(pluginFileName: string) {
		const existsPluginFolder = await this.offlineCache.fileExists(pluginFileName);
		if (!existsPluginFolder) {
			const staticBaseUrl = this.getStaticBaseUrl();
			const pluginUri = staticBaseUrl + '/plugin/' + pluginFileName;
			await this.offlineCache.retriableDownloadFile(5, pluginFileName, pluginUri, undefined, true);
		}
	}

	private async ensurePluginIsExtracted(pluginFilePath: string, pluginDirectoryPath: string) {
		const existsPlugin = await this.offlineCache.fileExists(pluginDirectoryPath);

		const pluginFile = await this.offlineCache.getFile(pluginFilePath);

		if (!existsPlugin && pluginFile) {
			await this.offlineCache.extractFile(pluginFilePath, pluginDirectoryPath, 'zip', true);
		}
	}

	private getPluginDirectory(archiveUri: string, md5Checksum: string): string {
		const relativePath = this.removeStaticUrl(archiveUri);
		return relativePath.substring(0, relativePath.lastIndexOf('/')) + '/' + md5Checksum;
	}

	private removeStaticUrl(archiveUri: string): string {
		const matches = archiveUri.match(/plugin\/(.+)$/);
		return matches ? matches[1] : archiveUri;
	}
}
